import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-71" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-2xl" data-id="element-72" data-mp="1ge0gur5br2f6">
        <div className="text-center" data-id="element-73" data-mp="1gausje4is4ki">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-74" data-mp="2e0ps7rlx2rdp">
            Hai ancora dubbi?
          </span>
          <h2 className="mt-4 font-display text-[1.85rem] font-black leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-75" data-mp="28za39ogmc0q1">
            Domande <span className="italic text-grape" data-id="element-76" data-mp="1z3ovtass688w">Frequenti</span>
          </h2>
        </div>

        <div className="mt-10 space-y-3" data-id="element-77" data-mp="smv44kuokq93">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-2xl bg-white" data-id="element-78" data-mp="nn8oy5vakzxn" data-mpi={index}>
                <h3 data-id="element-79" data-mp="pho9dqw2hklk">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-teal/40" data-id="element-80" data-mp="pj94piq7h7kh">
                    <span className="text-sm font-bold text-navy" data-id="element-81" data-mp="kibovcso4pm5">{faq.q}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-teal transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-82" data-mp="6rgchqiynqdt" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-83" data-mp="3syodkgmulb41">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: 'easeOut'
              }} className="overflow-hidden" data-id="element-84" data-mp="3t07u88cf1o6c">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-navy/60" data-id="element-85" data-mp="1ui5ovrq93bfk">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}